export function numberWithCommas(x) {
  if (!x) return '0';
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}



// WEBPACK FOOTER //
// ./src/utils/index.js